import React, {Component} from 'react';
import {View, Text, ScrollView, Modal} from 'react-native';
import Requests from '../api/Requests';
import {TableContainer} from '../components/table/Table';
import styled, {css} from 'styled-components/native';
import {colours} from '../styles/Style';
import {
  GetGlobalTheme,
  DataTypes,
  WindowTypes,
  IsHRWeb,
  GetDefaultBackBehaviour,
  IsHRiOS,
  WindowWrap,
  GetParameterID,
  goBack,
  DoNavigate,
  ScreenHeight,
  ScreenWidth,
  UsePagination,
  ResetRecord,
} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import {InspectWindow} from '../components/edit_elements/InspectWindow';
import {YesNoWindow} from '../components/status/YesNoWindow';
import EditField from '../components/edit_elements/EditField';
import {translate} from '../Tools/LanguageTools';
import {LoadSinglePasteSpecial} from '../App';
import {FixRecordMissingFields} from '../Tools/RecordTools';
import {RecordColumns, BrowseColumns} from './Columns/EmployeesColumns';
import {
  SetCurrentWindow2,
  AddWindowFilter,
  GetWindowFilter,
} from '../Tools/WindowTools';
import CheckboxButton from '../components/edit_elements/CheckboxButton';
import {createDrawerNavigator} from '@react-navigation/drawer';

const kDefPerPage = 20;

const Drawer = createDrawerNavigator();

let FilterView;
if (IsHRWeb()) {
  FilterView = styled.View`
    position: absolute;
    top: 100%;
    right: 0px;
    width: 240px;
    background: ${colours[GetGlobalTheme()].lightBackground};
    padding: 20px;
  `;
} else {
  if (IsHRiOS()) {
    FilterView = styled.View`
      position: absolute;
      height: ${ScreenHeight()};
      width: ${ScreenWidth()};
      background: ${colours[GetGlobalTheme()].lightBackground};
      padding: 6px;
    `;
  } else {
    FilterView = styled.Modal``;
  }
}

const FilterViewInner = styled.View`
  ${IsHRWeb() == false &&
  css`
    height: 100%;
    width: 100%;
    background-color: ${colours[GetGlobalTheme()].siteBackground};
  `};
  ${IsHRiOS() &&
  css`
    padding-top: 50;
  `};
`;

const FilterFields = styled.View`
  ${IsHRWeb() &&
  css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    /*margin-right: -30px;*/
  `}
`;
const FilterField = styled.View`
  ${IsHRWeb() &&
  css`
    width: 100%;
    /*margin-right: 30px;*/
  `}
`;
const FilterActions = styled.View`
  display: flex;
  ${(IsHRWeb() &&
    css`
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-end;
    `) ||
  css`
    flex-direction: column-reverse;
  `}
`;

class EmployeesList extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this._isMounted = true;
    this.createNewEmployee = this.createNewEmployee.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.renderNewButton = this.renderNewButton.bind(this);
    this.showExtraFilter = this.showExtraFilter.bind(this);
    this.ScreenName = 'Employees';
    this.table = 0;
    this.init = true;
    this.state = {
      data: [],
      record: {},
      show: false,
      update: false,
      px: 0,
      py: 0,
      WindowType: WindowTypes.Browse,
      newEmployeeHelper: false,
      NewPersonID: '',
      pagination: {
        page: 0,
        perpage: kDefPerPage,
        pages: 0,
        change: function (page) {
          self.changePage(page);
        },
        changePagePeriod: function (value) {
          self.changePagePeriod(value);
        },
      },
    };
    this.navigation = props.navigation;

    SetCurrentWindow2('Employees', 'EmpCode', 'ascending');
    if (global.userData.provider == 0) {
      AddWindowFilter('Employees', 'closed', '0');
    } else {
      AddWindowFilter('Employees', 'closedflag', '0');
    }
  }
  changePage = (page) => {
    let npagination = this.state.pagination;
    npagination.page = page;
    this.setState({pagination: npagination});
  };
  changePagePeriod = (value) => {
    let npagination = this.state.pagination;
    npagination.perpage = value;
    npagination.page = 0;
    this.setMatrixPagination(this.state.record.rows.length);
    this.setState({pagination: npagination});
  };
  getBrowseListData = () => {
    let self = this;
    Requests.getTableData(0, undefined, undefined, undefined, true)
      .then((response) => {
        if (self._isMounted) {
          self.setState({data: response.records});
        }
      })
      .catch((error) => {});
  };

  displayBrowseList = () => {
    this.state.WindowType = WindowTypes.Browse;
    this.getBrowseListData();
  };
  componentWillUnmount() {
    this._isMounted = false;
  }
  rowClick = (id) => {
    DoNavigate(this, 'Employees', true, id);
  };

  createNewEmployee = () => {
    if (this.state.NewPersonID == '') {
      global.messageBox({
        showMessage: true,
        statusMessage: translate('FillMandFields'),
      });
      return;
    }

    let self = this;
    let tdata = {
      record: {
        PersonIDNr: this.state.NewPersonID,
        EmpTypeFlag: 1,
      },
    };
    Requests.getNewRecord(0, tdata)
      .then((response) => {
        this.state.NewEmp = '';
        self.ShowHideNewEmployee();
        if (UsePagination() == false) {
          self.getBrowseListData();
        }
        self.rowClick(response.record['EmpCode']);
      })
      .catch((error) => {});
  };
  ShowHideNewEmployee = () => {
    if (this.state.newEmployeeHelper) {
      global.PopEscapeActions();
      this.setState({newEmployeeHelper: false});
    } else {
      this.setState({newEmployeeHelper: true});
      global.PushEscapeActions(() => this.ShowHideNewEmployee());
    }
  };
  componentDidMount() {
    let self = this;
    this.focusSubscription = this.props.navigation.addListener('focus', () => {
      SetCurrentWindow2('Employees', '', '');
      if (UsePagination() == false) {
        self.getBrowseListData();
      } else {
        if (self.init == false) {
          self.setState({update: self.state.update ? false : true});
        }
        self.init = false;
      }
    });
  }
  DisplayBrowseClosed = (value, curval) => {
    if (curval == '1') {
      return <Text>✔</Text>;
    } else {
      return <Text></Text>;
    }
  };

  showExtraFilter = (browsewindow) => {
    let self = this;
    if (global.userData.provider == 0) {
      return (
        <View>
          <CheckboxButton
            value={GetWindowFilter('Employees', 'closed') == '0' ? '0' : '1'}
            onChange={(test, test2, value) => {
              if (value == 1) {
                AddWindowFilter('Employees', 'closed', null);
              } else {
                AddWindowFilter('Employees', 'closed', '0');
              }
              if (UsePagination()) {
                self.setState({update: self.state.update ? false : true});
                browsewindow.GetTableData();
              } else {
                self.setState({update: self.state.update ? false : true});
              }
            }}
            editable={true}
            title={translate('ShowActive')}
            title2={translate('ShowAll')}
          />
        </View>
      );
    }
  };

  renderNewButton = () => {
    let self = this;
    let style = {};
    if (IsHRWeb()) {
      style = {marginRight: '20px'};
    }
    let style2 = {};
    if (IsHRiOS()) {
      style2 = {
        left: -this.state.px,
        top: -this.state.py,
      };
    }
    let scrollstyle = {};
    if (IsHRWeb()) {
      scrollstyle = {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      };
    }
    return (
      <View
        key={'employee_new'}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          self.setState({py: layout.y, px: layout.x});
        }}
      >
        <ActionButton
          onPress={() => this.ShowHideNewEmployee()}
          title={translate('AddNew')}
        />
        {this.state.newEmployeeHelper && (
          <FilterView style={style2}>
            <FilterViewInner>
              <ScrollView contentContainerStyle={scrollstyle}>
                <FilterFields>
                  <FilterField>
                    <EditField
                      title={translate('PersonID') + '*'}
                      name={'PersonIDNr'}
                      value={this.state.NewPersonID}
                      type={DataTypes.kInputTypeNumber2}
                      onChange={(index, fn, value) => {
                        self.setState({NewPersonID: value});
                        self.state.NewPersonID = value;
                      }}
                    />
                  </FilterField>
                </FilterFields>
                <FilterActions>
                  <ActionButton
                    style={style}
                    onPress={() => this.ShowHideNewEmployee()}
                    title={translate('Cancel')}
                  />
                  <ActionButton
                    onPress={() => this.createNewEmployee()}
                    title={translate('Create')}
                  />
                </FilterActions>
              </ScrollView>
            </FilterViewInner>
          </FilterView>
        )}
      </View>
    );
  };
  render() {
    return (
      <WindowWrap>
        <TableContainer
          table={this.table}
          update={this.state.update}
          data={this.state.data}
          columns={BrowseColumns(this)}
          doClick={this.rowClick}
          extraFilter={this.showExtraFilter}
          rowID={'empcode'}
          title={translate(this.ScreenName)}
          width="800px"
          extraContent={this.renderNewButton}
        />
      </WindowWrap>
    );
  }
}

export class EmployeesRecord extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this._isMounted = true;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateRecordField = this.updateRecordField.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.ScreenName = 'Employees';
    this.table = 0;
    this.state = {
      data: [],
      record: {},
      show: false,
      update: false,
      ActiveID: '',
      WindowType: WindowTypes.Browse,
      newEmployeeHelper: false,
      NewPersonID: '',
      pagination: {
        page: 0,
        perpage: kDefPerPage,
        pages: 0,
      },
    };
    this.navigation = props.navigation;

    if (props.route.params?.id) {
      this.state.ActiveID = props.route.params.id;
      this.rowClick(props.route.params.id);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  setMatrixPagination = (cnt) => {
    this.state.pagination.page = 0;
    this.state.pagination.pages =
      parseInt(cnt / this.state.pagination.perpage) + 1;
  };
  rowClick = (id) => {
    let self = this;
    this.state.WindowType = WindowTypes.Inspect;
    this.setState({record: {}});
    Requests.getTableData(0, {EmpCode: id}, undefined, undefined, true)
      .then((response) => {
        self.setMatrixPagination(response.records[0].rows.length);
        self.setState({
          id: response.records[0]['EmpCode'],
          record: response.records[0],
        });
      })
      .catch((error) => {});
  };
  updateRecordField = (rowindex, index, value) => {
    let self = this;
    Requests.updateRecordData(0, {
      field: index,
      rownr: rowindex,
      value: value,
      id: this.state.record.EmpCode,
    })
      .then((response) => {
        if (response.success) {
          self.state.record = {};
          let record = FixRecordMissingFields(
            response.record,
            RecordColumns(this)
          );

          self.setState({record: record});
          if (index == 'Name' || index == 'EmpCode' || index == 'DepCode') {
            //LoadSinglePasteSpecial(0, {});
          }
        } else {
          ResetRecord(self, index, rowindex, value);
        }
      })
      .catch((error) => {});
  };

  handleInputChange = (rowindex, index, event) => {
    this.updateRecordField(rowindex, index, event.target.value);
  };

  componentDidUpdate() {
    let param_id = GetParameterID(this);
    if (this.state.ActiveID != param_id && param_id != '') {
      this.state.ActiveID = param_id;
      this.rowClick(this.state.ActiveID);
    }
  }
  deleteRecord = () => {
    let self = this;
    this.setState({activeDelete: false});
    Requests.deleteRecord(0, this.state.record.EmpCode)
      .then((response) => {
        self.state.ActiveID = '';
        DoNavigate(self, 'Employees', false, '', true, true);
      })
      .catch((error) => {});
  };

  render() {
    let self = this;
    return (
      <>
        <WindowWrap>
          <InspectWindow
            title={translate('Employee')}
            window={this}
            headerfields={RecordColumns(this)}
            record={this.state.record}
            onClick={this.handleInputClick}
            allowDelete={true}
            allowPrint={false}
            backButton={() => goBack(self, self.ScreenName)}
          />
          {this.state.activeDelete && (
            <Modal transparent={true}>
              <YesNoWindow
                question={translate('RemoveQuestion')}
                yes={() => this.deleteRecord()}
                no={() => this.setState({activeDelete: false})}
              />
            </Modal>
          )}
        </WindowWrap>
      </>
    );
  }
}

function Employees() {
  return (
    <Drawer.Navigator
      style={{background: 'white'}}
      screenOptions={{headerShown: false}}
      backBehavior={GetDefaultBackBehaviour()}
      drawerStyle={{display: 'none'}}
    >
      <Drawer.Screen
        name="EmployeesList"
        component={EmployeesList}
        options={{
          title: translate('Employees'),
        }}
      />
      <Drawer.Screen
        name="EmployeesRecord"
        component={EmployeesRecord}
        backBehavior={GetDefaultBackBehaviour()}
        options={{
          title: translate('Employee'),
        }}
        getId={({params}) => params.id}
      />
    </Drawer.Navigator>
  );
}

export default Employees;
